export default __webpack_public_path__ + "static/media/logo-text.41c5956f.png";